import { render, staticRenderFns } from "./PortalLinkMenus.vue?vue&type=template&id=460aa07e&scoped=true&"
import script from "./PortalLinkMenus.vue?vue&type=script&lang=ts&"
export * from "./PortalLinkMenus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460aa07e",
  null
  
)

export default component.exports